/**
 * The configuration file for the tsconfig file upgrading to Angular 15.
 */

export const baseReplaces = {
    '"module": "es2020"': '"module": "esnext"',
    '"target": "es2015"': '"target": "ES2022"',
}

export const baseDirectReplaces = {
    '  "es2018"': '  "ES2022"'
}

export const replaces = {
    '"target": "ES5"': '"target": "ES2022"'
}
